import { of } from 'rxjs/observable/of';
import { Observable } from 'rxjs';
import { fromPromise } from 'rxjs/observable/fromPromise';
import { switchMap, catchError, exhaustMap } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { Action } from 'redux-actions';

import {
	GET_MAKE_UP_PUNCH_RULE_SETTING_CALL,
} from '@src/store/types/makeUpPunchRule';

import {
	getMakeUpPunchRuleSettingDone,
	getMakeUpPunchRuleSettingFail,
} from '@src/store/actions/makeUpPunchRule';
import {
	getMakeUpPunchRuleSetting,
} from '@src/services/makeUpPunchRule';

export const getMakeUpPunchRuleSettingEpic = (
	action$: Observable<Action>,
): Observable<Action> => action$.pipe(
	ofType(GET_MAKE_UP_PUNCH_RULE_SETTING_CALL),
	exhaustMap(
		() => fromPromise(getMakeUpPunchRuleSetting()).pipe(
			switchMap(res => of(getMakeUpPunchRuleSettingDone({ res }))),
			catchError(error => of(getMakeUpPunchRuleSettingFail({ error }))),
		),
	),
);
